import * as React from 'react';
import { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/free-solid-svg-icons';
import papers from '../../images/papers.jpg';
import { BaseLayout } from '../../layouts';
import { FileSize } from '../../widgets';
import { useModel } from './model';
export var SharePage = function () {
    var model = useModel();
    return (React.createElement(BaseLayout, null,
        React.createElement("section", { className: "UsersPage container-sm" },
            React.createElement("div", { className: "card" },
                React.createElement("img", { src: papers, className: "card-img-top", alt: "" }),
                React.createElement("div", { className: "card-body" },
                    !model.share &&
                        React.createElement(Fragment, null,
                            React.createElement("h2", { className: "h5 card-title" }, "Dokument abrufen"),
                            React.createElement("p", { className: "card-text" }, "Bitte geben sie den Code ein, der Ihnen genannt wurde"),
                            React.createElement("form", { onSubmit: function (evt) { evt.preventDefault(); model.load(); } },
                                React.createElement("div", { className: "input-group" },
                                    React.createElement("input", { className: "form-control", value: model.slug, onChange: function (evt) { model.setSlug(evt.target.value); } }),
                                    React.createElement("button", { className: "btn btn-primary" }, "Freigabe \u00D6ffnen")))),
                    model.share &&
                        React.createElement(Fragment, null,
                            React.createElement("h2", { className: "h5 card-title" }, "Dateien herunterladen"),
                            React.createElement("p", null, "In dieser Freigabe sind folgende Dateien enthalten:"),
                            React.createElement("ul", { className: "list-group my-3" }, model.share.files.map(function (file) {
                                return React.createElement("li", { className: "list-group-item d-flex justify-content-between align-items-center" },
                                    React.createElement("a", { style: { fontSize: '150%', textDecoration: 'none' }, href: "/api/shares/" + model.share.slug + "/files/" + file.id + "/download/" },
                                        React.createElement(FontAwesomeIcon, { icon: faFile }),
                                        ' ',
                                        file.filename),
                                    React.createElement(FileSize, { className: "text-muted", size: file.size }));
                            })),
                            React.createElement("p", null,
                                "Die Freigabe ist bis zum ",
                                React.createElement("em", null, model.share.delete_at),
                                " verf\u00FCgbar")))))));
};
